import axios from 'axios';
import { IMainSubscription } from '@pec/aion-ui-core/interfaces/mainSubscription';
import { IOrganizationInfo } from '@pec/aion-ui-core/interfaces/organizationInfo';
import { IUserInfo } from '@pec/aion-ui-core/interfaces/userInfo';
import { ICompleteResponse } from 'surveyjs/common/types/complete';
import { ITaxRate } from 'surveyjs/common/types/products';
import { _DeepReadonlyObject } from 'utility-types/dist/mapped-types';
import { TaxIncludeLocation } from 'interfaces/onlineTraining';

enum HumanFocus {
  focus = 'Human Focus',
  type = 'ThirdPartyAddon'
}
type Payload = {
  organizationInfo: IOrganizationInfo;
  taxRate: ITaxRate | null;
  userInfo: _DeepReadonlyObject<IUserInfo>;
  productSelect: string;
  quantity: number;
  mainSubscription: IMainSubscription;
};
export const handleCompletion = async (payload: Payload) => {
  const { organizationInfo, taxRate, productSelect, quantity, userInfo, mainSubscription } = payload;
  const { emailAddress: email, userId } = userInfo;
  const { id: subscriptionId, countryISO2: location } = mainSubscription;
  const { id: organizationId, employeeCount, countryIso2Code } = organizationInfo;

  const products = [productSelect];

  const body = {
    organizationId,
    subscriptionId,
    email,
    userId,
    products,
    quantity,
    location,
    subscriptionTier: HumanFocus.focus,
    operationType: HumanFocus.type,
    productType: HumanFocus.focus,
    totalEmployeeCount: employeeCount.employeeCount,
    successUrl: `${window.location.origin}/organizations/${organizationId}#products`,
    cancelUrl: `${window.location.origin}/organizations/${organizationId}/online-training`,
    taxRateId: taxRate?.isActive && TaxIncludeLocation[countryIso2Code] ? taxRate?.paymentProviderRateId : null,
    discountCodeId: null,
    discountCode: null,
    dataSharingConsent: null
  };

  return axios.post<ICompleteResponse>(
    `/api/v1/organizations/${organizationId}/subscriptions/${subscriptionId}/checkout`,
    body
  );
};
